import { Controller } from "stimulus"
import Rails from "@rails/ujs";
import ContentLoader from "../content_loader_controller"

export default class extends ContentLoader {
 static targets = ['loaderUrl', 'scrollable']

 postSuccessHook() {
  self = this
  setTimeout(function() {
    self.scrollableTarget.dispatchEvent(new Event("scrollable::will-scroll"))
  }, 100);

 }


  url() {
    return this.loaderUrlTarget.innerHTML
  }
}
